// Arquivo: src/utils/helpers.js

/**
 * --- Constantes de Agrupamento por CPA (Baseado no PDF) ---
 * Mapeamento de Batalhão para CPA
 */
export const CPAS_BPM = {
  "CPA/M-1 (Região Central)": ["7º BPM/M", "11º BPM/M", "13º BPM/M", "7º ΒΑΕΡ"],
  "CPA/M-2 (Região Sudeste)": ["3º BPM/M", "12º BPM/M", "46º BPM/M"],
  "CPA/M-3 (Região Norte)": ["5º BPM/M", "9º BPM/M", "18º BPM/M", "43º BPM/M"],
  "CPA/M-4 (Região Leste)": [
    "2º BPM/M",
    "29º BPM/M",
    "39º BPM/M",
    "48º BPM/M",
    "4º ΒΑΕΡ",
  ],
  "CPA/M-5 (Região Oeste)": ["4º BPM/M", "23º BPM/M", "16º BPM/M", "49º BPM/M"],
  "CPA/M-9 (Região Leste 2)": ["19º BPM/M", "28º BPM/M", "38º BPM/M"],
  "CPA/M-10 (Região Sul)": ["1º BPM/M", "22º BPM/M", "27º BPM/M", "37º BPM/M"],
  "CPA/M-11 (Região Leste 3)": ["8º BPM/M", "21º BPM/M"],
  "CPA/M-6 (ABC Paulista)": [
    "6º BPM/M",
    "10º BPM/M",
    "24º BPM/M",
    "30º BPM/M",
    "6º ΒΑΕΡ",
  ],
  "CPA/M-7 (Guarulhos)": ["15º BPM/M", "26º BPM/M", "31º BPM/M", "15º BAEP"],
  "CPA/M-8 (Osasco)": [
    "14º BPM/M",
    "20º BPM/M",
    "25º BPM/M",
    "33º BPM/M",
    "36º BPM/M",
    "5º ΒΑΕΡ",
  ],
  "CPA/M-12 (Alto do Tietê)": ["17º BPM/M", "32º BPM/M", "35º BPM/M"],
  "CPI-1 (SJC)": ["46º BPM/I", "3º ΒΑΕΡ"],
  "CPI-2 (Campinas)": ["8º BPM/I", "1º ΒΑΕΡ"],
  "CPI-6 (Santos)": ["21º BPM/I", "2º ΒΑΕΡ"],
  "CPI-9 (Piracicaba)": ["48º BPM/I"],
  "Especializado (CPRV)": ["1º BPRv", "6º BPRv - 2ª Cia"],
  "Especializado (CPChq)": ["1º BPChq", "2º BPChq"],
  "Especializado (CPTran)": ["1º BPTran", "2º BPTran"],
  // Locais Jurídicos (PJ)
  "Estágio Jurídico (PJ)": ["Tribunal de Justiça", "Ministério Público"], // Exemplo de local PJ
};

/**
 * Mapeamento de Batalhão para Área de Atuação (Descrição)
 * (Usado para os cards PCO/Operacionais)
 */
export const DESCRICAO_LOCAL = {
  // CPA/M-6 (ABC Paulista)
  "6º BPM/M": "São Bernardo do Campo e São Caetano do Sul",
  "10º BPM/M": "Santo André",
  "24º BPM/M": "Diadema",
  "30º BPM/M": "Mauá, Ribeirão Pires e Rio Grande da Serra",
  "6º ΒΑΕΡ": "Toda a região do CPA/M-6 (Ações Especiais)",
  // CPA/M-7 (Guarulhos e região)
  "15º BPM/M": "Guarulhos",
  "26º BPM/M":
    "Franco da Rocha, Cajamar, Mairiporã, Caieiras e Francisco Morato",
  "31º BPM/M": "Guarulhos, Santa Isabel e Arujá",
  "15º BAEP": "Toda a região do CPA/M-7 (Ações Especiais)",
  // CPA/M-8 (Osasco e região)
  "14º BPM/M": "Osasco",
  "20º BPM/M": "Barueri, Santana de Parnaíba, Jandira e Itapevi",
  "25º BPM/M": "Itapecerica da Serra",
  "33º BPM/M": "Carapicuiba, Cotia e Vargem Grande Paulista",
  "36º BPM/M": "Embu das Artes e Taboão da Serra",
  "5º ΒΑΕΡ": "Toda a região do CPA/M-8 (Ações Especiais)",
  // CPA/M-12 (Região do Alto do Tietê)
  "17º BPM/M": "Mogi das Cruzes",
  "32º BPM/M": "Suzano e Ferraz de Vasconcelos",
  "35º BPM/M": "Itaquaquecetuba",
  // Adicionar outros BPMs mapeados no CPAS_BPM sem descrição detalhada (para evitar "Grandes Comandos")
  "7º BPM/M": "Região Central de São Paulo",
  "11º BPM/M": "Região Central de São Paulo",
  "13º BPM/M": "Região Central de São Paulo",
  "3º BPM/M": "Região Sudeste de São Paulo",
  "12º BPM/M": "Região Sudeste de São Paulo",
  "46º BPM/M": "Região Sudeste de São Paulo",
  // Se for PJ, usamos uma descrição padrão
  "Tribunal de Justiça":
    "Fóruns da Capital e Região Metropolitana (Policiamento Judiciário)",
  "Ministério Público": "Promotorias de Justiça (Policiamento Judiciário)",
};

/**
 * Retorna o nome do CPA de um Batalhão cadastrado como Local.
 * @param {string} localNome - O nome do local (ex: "14º BPM/M").
 * @returns {string} O nome do CPA (ex: "CPA/M-8 (Osasco)") ou o grupo PJ/Especializado.
 */
export const getCPAName = (localNome) => {
  // Tenta o match exato primeiro
  for (const cpa in CPAS_BPM) {
    if (CPAS_BPM[cpa].includes(localNome)) {
      return cpa;
    }
  }

  // Se for uma unidade jurídica (PJ), retorna o novo grupo
  if (
    localNome.includes("Tribunal") ||
    localNome.includes("Fórum") ||
    localNome.includes("Jurídica") ||
    localNome.includes("Ministério")
  ) {
    // MUDANÇA: Substituído pelo novo nome do grupo PJ
    return "Grandes Comandos - PPJM";
  }

  // Tenta um match parcial para locais sem o sufixo exato (ex: "14º BPM/M" vs "14º BPM/M (Osasco)")
  for (const cpa in CPAS_BPM) {
    for (const batalhao of CPAS_BPM[cpa]) {
      // Comparação mais robusta, ignorando espaços e casos
      const cleanBatalhao = batalhao.replace(/[^\w]/g, "").toLowerCase();
      const cleanLocal = localNome.replace(/[^\w]/g, "").toLowerCase();

      if (cleanLocal.startsWith(cleanBatalhao.substring(0, 5))) {
        return cpa;
      }
    }
  }

  // MUDANÇA: Substituído pelo novo nome do grupo PJ
  return "Grandes Comandos - PPJM";
};

/**
 * Retorna a descrição do raio de atuação para o card de estágio.
 */
export const getLocalDescription = (localNome) => {
  // Retorna a descrição detalhada, ou o nome do local se não houver descrição específica
  return (
    DESCRICAO_LOCAL[localNome] ||
    `Unidade ${localNome} - Área de atuação não detalhada.`
  );
};

/**
 * NOVO: Função para extrair o nome completo (sem posto/grad)
 */
export const getNomeCompleto = (nomeCompletoComPosto) => {
  if (!nomeCompletoComPosto || typeof nomeCompletoComPosto !== "string")
    return "";
  // Tenta remover 'Cad PM', 'Al Of PM', '1º Ten PM', etc., e o nome de guerra/apelido (ex: "(Admin)")
  const parts = nomeCompletoComPosto.split(" ");
  let nome = parts
    .filter((p) => !p.includes("PM") && !p.includes("(") && !p.includes(")"))
    .join(" ");
  // Remove múltiplos espaços e retorna
  return nome.trim().replace(/\s+/g, " ");
};

/**
 * Limpa o CPF para conter apenas 11 dígitos
 * @param {string} cpf - O CPF a ser limpo
 * @returns {string} - CPF com 11 dígitos
 */
export const limparCPF = (cpf) => {
  if (typeof cpf !== "string") return "";
  return cpf.replace(/[^\d]+/g, "");
};

/**
 * Formata um Timestamp do Firestore ou objeto Date para string (dd/MM/yyyy)
 */
export const formatarData = (timestamp) => {
  if (!timestamp) return "N/A";
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  return date.toLocaleDateString("pt-BR", { timeZone: "America/Sao_Paulo" });
};

/**
 * Retorna o dia da semana (0=Domingo, 1=Segunda, ..., 6=Sábado)
 */
export const getDiaDaSemana = (data) => {
  // Aceita timestamp ou string de data (do formulário)
  let date;
  if (data.toDate) {
    date = data.toDate();
  } else if (typeof data === "string") {
    date = new Date(data + "T12:00:00Z"); // Trata string como UTC
  } else {
    date = new Date(data);
  }
  return date.getDay();
};

/**
 * Retorna a string da data normalizada (yyyy-MM-dd) a partir de um Timestamp ou Date
 * @param {Timestamp | Date} timestamp - O objeto de data
 * @returns {string} - Data normalizada (ex: "2025-12-01")
 */
export const getNormalizedDateString = (timestamp) => {
  if (!timestamp) return "";
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  const offset = date.getTimezoneOffset();
  const localDate = new Date(date.getTime() - offset * 60 * 1000);
  return localDate.toISOString().split("T")[0];
};